import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home.js';
import ScrollToTop from './helper/scroll-to-top/scroll-to-top.tsx'
function App() {
  return (<>
    <Routes>
      <Route path="/" element={<Home />} />
    </Routes>
    <ScrollToTop />
  </>
  );
}

export default App;
